// import React, { useState, useEffect } from "react";
// import Layout from "../components/Layout";
// import { Link } from "react-router-dom";


// const Networks = () => {

//     const [networks, setNetworks] = useState([]);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         async function fetchData() {
//             try {
//                 const response = await fetch('/api/network/'); // Убедитесь, что URL правильный
//                 if (!response.ok) {
//                     throw new Error(`HTTP error! status: ${response.status}`);
//                 }
//                 const data = await response.json();
//                 setNetworks(data);
//             } catch (error) {
//                 console.error('Error fetching networks:', error);
//             } finally {
//                 setLoading(false);
//             }
//         }

//         fetchData();
//     }, []);

//     return (
//         <Layout>
//             <div className="networks">
//                 <div className="container">
//                     <div className="networks-all">
//                         <p className="networks-all__title">110-500 кВ электр узатиш ҳаво тармоқлари</p>
//                         <ul className="networks-all__list list">
//                             {networks.map(network => (
//                                 <li key={network.id} className="list-item"><Link className="list-item__link" to={`/indicators/networks/${network.slug}`}>{network.name}</Link></li>
//                             ))}
//                         </ul>
//                     </div>
//                 </div>
//             </div>
//         </Layout>
//     )
// }


// export default Networks;

import React from "react";
import EntitiesList from "../components/entitiesList/EntitiesList";

const NetworksPage = () => {
    return (
        <EntitiesList 
            entityType="network" 
            apiEndpoint="/api/network" 
            reportType="formnetworkId" 
        />
    );
};

export default NetworksPage;
